var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// D:/ThinkBIT/work-projects/confe/hosting/~/core-js/modules/_cof.js
// module id = ../../../../core-js/modules/_cof.js
// module chunks = 18